import React from 'react';

type BadgeVariant =
  | 'submitted' |'quoted' |'accepted' |'scheduled' |'inprogress' |'completed' |'declined' |'general' |'issue' |'concern' |'followup' |'escalated' |'default';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

const variantMap: Record<BadgeVariant, string> = {
  submitted: 'badge-status-submitted',
  quoted: 'badge-status-quoted',
  accepted: 'badge-status-accepted',
  scheduled: 'badge-status-scheduled',
  inprogress: 'badge-status-inprogress',
  completed: 'badge-status-completed',
  declined: 'badge-status-declined',
  general: 'badge-severity-general',
  issue: 'badge-severity-issue',
  concern: 'badge-severity-concern',
  followup: 'badge-severity-followup',
  escalated: 'badge-severity-escalated',
  default: 'bg-muted text-muted-foreground border border-border',
};

export default function Badge({ variant = 'default', children, className = '' }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${variantMap[variant]} ${className}`}
    >
      {children}
    </span>
  );
}